import { ReactNode, createContext, useState } from "react";
import { DocumentsHistory, MemberClaims, MemberRecord, HistoricalPaymentDetail, Profile, ScheduledPaymentDetail } from "../models/memberclaims";

type Props = {
    children?: ReactNode;
}

export type UserContext = {
    memberDetails?: MemberRecord;
    memberId?: number;
    claims: MemberClaims[];
    yourDetails?: Profile;
    otherDocuments?: DocumentsHistory[];
    historicalPayments?: HistoricalPaymentDetail[];
    scheduledPayments?: ScheduledPaymentDetail[];
}


type IUserContext = {
    contextData: UserContext;
    setUserContext: React.Dispatch<React.SetStateAction<UserContext>>;
}

const initialValue:IUserContext = {
    
    contextData: {
        memberDetails: {} as MemberRecord,
        claims: [] as any[],
        yourDetails: {} as Profile,
        otherDocuments: [] as any[],
    },
    setUserContext: () => { }
}

const UserContext = createContext<IUserContext>(initialValue);

const UserContextProvider = ({ children }: Props) => {
    const [contextData, setUserContext] = useState(initialValue.contextData)

    return (
        <UserContext.Provider value={{ contextData, setUserContext }}>
            {children}
        </UserContext.Provider>
    )
}

export { UserContext, UserContextProvider }